import React, { FunctionComponent } from "react";
import { Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import cs from "classnames";
import { useTranslation } from "react-i18next";
import { CupRecord, RaceResult } from "/src/domain/challenges/ChallengeRatingCup";
import { sec2hms } from "/src/utils/time-utils";

export type CupParticipantInfoProps = {
    className?: string,
    record: CupRecord
};

export const CupParticipantInfo: FunctionComponent<CupParticipantInfoProps> = ({ className, record }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <div className={cs(className, classes.container)}>
            {record.raceResults.map((result: RaceResult, index: number) => (
                <div className={classes.race} key={index}>
                    <Typography variant={"subtitle1"} className={classes.raceResultValue}>{t('race')} {index + 1}</Typography>
                    <Typography variant={"body1"} className={classes.raceResultValue}>
                        {t('time')}: {sec2hms(result.time)}
                    </Typography>
                    <Typography variant={"body1"} className={classes.raceResultValue}>
                        {t('absolute')}: {sec2hms(result.absolute)}
                    </Typography>
                </div>
            ))}
        </div>
    );
};

const useStyles = makeStyles({
    container: {
        padding: "1rem 2rem"
    },
    race: {
        marginBottom: "1rem"
    },
    raceResult: {
        fontSize: "1rem"
    },
    raceResultValue: {
        fontSize: '0.8rem'
    },
})